<template>
  <form class="user-invitation-page" @submit.prevent="assignUserInvitation">
    <label for="user-email" class="invitation-label"
      >Assign User Invitation</label
    >
    <input
      id="user-email"
      v-model="userEmail"
      type="email"
      required
      class="invitation-input mt-4"
      placeholder="Enter user email"
    />
    <button
      class="p-3 shadow-md px-12 rounded-full mt-6 mb-8 border-none text-white font-bold bg-green"
    >
      Assign Invitation
    </button>
  </form>
</template>

<script>
import { assignInvitation } from "@/apis/edyst_cms/index"

export default {
  data() {
    return {
      userEmail: undefined,
    }
  },
  methods: {
    assignUserInvitation() {
      assignInvitation(this.userEmail)
        .then(() => {
          this.$noty.success("Successfully Assigned the User Invitation!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(err => {
          this.$swal({
            icon: "error",
            text: err.response.data.message,
          })
        })
    },
  },
}
</script>

<style scoped>
.user-invitation-page {
  max-width: 500px;
  margin: auto;
  margin-top: 30px;
}
.invitation-label {
  font-size: 18px;
  cursor: pointer;
}
.invitation-input {
  padding: 10px;
  border: 2px solid grey;
  border-radius: 5px;
}
</style>
